import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { clearOrders } from "../../../redux/ordersSlice";
import { clearCart } from "../../../redux/cartSlice";

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const clearAuthData = () => {
    // Clear all local storage items
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    localStorage.removeItem("vendorId");
    
    // Clear all cookies
    const cookies = document.cookie.split(";");
    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=" + window.location.hostname + ";path=/";
    });

    // Clear session storage
    sessionStorage.clear();

    // Clear Redux state
    dispatch(clearOrders());
    dispatch(clearCart());
  };

  const handleLogout = () => {
    clearAuthData();
    toast.success("Logged out successfully!");
    navigate("/login");
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="flex items-center justify-center h-full bg-gray-50 animate-fadeIn">
      <div className="bg-white shadow-lg border border-gray-200 rounded-2xl p-10 max-w-md w-full text-center">

        {/* ICON */}
        <div className="flex justify-center mb-4">
          <div className="p-4 rounded-full bg-gray-100 border border-gray-200">
            <LogOut className="w-10 h-10 text-gray-700" />
          </div>
        </div>

        {/* TITLE */}
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Logout Confirmation
        </h2>

        {/* TEXT */}
        <p className="text-gray-600 mb-7">
          Are you sure you want to log out? You will be redirected to the login page.
        </p>

        {/* ACTION BUTTONS */}
        <div className="flex items-center justify-center gap-4">

          {/* CANCEL BUTTON */}
          <button 
            onClick={handleCancel}
            className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 bg-white hover:bg-gray-100 transition active:scale-95"
          >
            Cancel
          </button>

          {/* LOGOUT BUTTON */}
          <button 
            onClick={handleLogout}
            className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition active:scale-95 flex items-center gap-2"
          >
            <LogOut className="w-5 h-5" />
            Logout
          </button>

        </div>
      </div>
    </div>
  );
};

export default Logout;
